import React, {useRef, useEffect} from 'react';
import './Input.less';

function moveCursorToInputEnd(inputRef) {
	inputRef.current.selectionStart = inputRef.current.value.length;
	inputRef.current.selectionEnd = inputRef.current.value.length;
}

export const Input = ({value, regex, inputMode, onChange, placeholder, ref, isMultiline, focusOnMount, id}) => {

	const inputRef = ref || useRef(null);

	useEffect(() => {
		if (!focusOnMount) return;

		inputRef && inputRef.current.focus({preventScroll: true});
	}, [])

	function validateAndChange(e) {
		if (!e) return;
		if (regex && !regex.test(e.target.value)) return;

		onChange(e.target.value);
	}

	function onFocus() {
		setTimeout(() => {
			moveCursorToInputEnd(inputRef);
		}, 0);
	}

	if (isMultiline) {
		return <textarea
			className="input input--multiline"
			onChange={validateAndChange}
			onFocus={onFocus}
			value={value}
			placeholder={placeholder}
			ref={inputRef}
		></textarea>
	} else {
		return <input
			id={id}
			ref={inputRef}
			className="input"
			inputMode={inputMode}
			onChange={validateAndChange}
			onFocus={onFocus}
			value={value}
			placeholder={placeholder}
		/>
	}
}
